import React from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { MIN_SIGNERS } from '../../constants';
import { useRecentSignersConnection } from '../../hooks/useRecentSignersConnection';
import { AccessibleDescription } from '../AccessibleDescription';
import { ActivityPill, ActivityScroller } from '../ActivityScroller';

export const RecentSignersViewportSmall: React.FC = () => {
	const recentSigners = useRecentSignersConnection();
	const isSunriseThemeEnabled = useIsSunriseTheme();

	if (recentSigners.length < MIN_SIGNERS) {
		return null;
	}
	return (
		<Box
			mb={24}
			sx={{
				// This makes the element overlap the padding from the MainContainer so that the list appears to scroll
				// off the edges of the device (viewport).
				marginX: -16,
				...(isSunriseThemeEnabled && {
					display: 'flex',
					flexDirection: 'column',
					gap: 8,
				}),
			}}
			data-testid="recent-signers-mobile"
		>
			{isSunriseThemeEnabled && (
				<Text fontWeight="bold" size="default" sx={{ marginLeft: 16 }}>
					<Translate value="corgi.petition_gamma.recent_signers.title" />
				</Text>
			)}
			<ActivityScroller aria-hidden>
				{recentSigners.map((signer) => (
					<ActivityPill
						key={signer.id}
						title={signer.displayName}
						time={signer.createdAtRelativeLocalized}
						sx={{
							// Reintroduce the margin within the scrolling area:
							marginLeft: 16,
							scrollMarginLeft: 16,
						}}
					/>
				))}
			</ActivityScroller>

			<AccessibleDescription />
		</Box>
	);
};
